export default __webpack_public_path__ + "static/media/error_outline_dp.f1ff4f51.svg";